import { gql } from '@apollo/client';

export const HOST = gql`
  query sidebarData($id: Int!) {
    hostOverview(id: $id) {
      alias
      mac_addr
      ip_addr
      in_service
      online
      device_has_changed
      comment

      bookings {
        id
      }

      client_sessions {
        id
      }

      info {
        processor
        ram
        video
        disc
      }

      counters {
        active_window

        disk_status {
          letter
          total
          used
        }
      }
    }
  }
`;

export const APPLY_NEW_CONFIG = gql`
  mutation applyNewHostDevices($id: Int!) {
    applyNewHostDevices(id: $id) {
      id
      device_has_changed
    }
  }
`;

export const GET_HOST_BY_ID = gql`
  query hostsByIds($ids: [Int!]!) {
    hostsByIds(ids: $ids) {
      comment
      info {
        processor
        ram
        video
        disc
      }
      counters {
        active_window

        disk_status {
          letter
          total
          used
        }
      }
      alias
      mac_addr
      ip_addr
      device_has_changed
      in_service
      online
      bookings {
        id
      }
      client_sessions {
        id
      }
    }
  }
`;
